import { render, staticRenderFns } from "./addUsers.vue?vue&type=template&id=f5b311dc"
import script from "./addUsers.vue?vue&type=script&lang=js"
export * from "./addUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports